import PropTypes from 'prop-types';
import React from 'react';

const TextViewer = ({ label, value }) => {
     return (
        <div className='formComponent'>
            <div className="input-group">
                {label ? <label className='input-group-addon'>{label}</label> : ''}
                <label className='form-control' disabled>{value}</label>
            </div>
        </div>
    );
};

TextViewer.propTypes = {
    label: PropTypes.string, // Label
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default TextViewer;